import React from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { visiUserData, isAdLookupRole } from './GeneralFunction';
import { NotFound  } from "./components/404NotFound/404NotFound";
import { ONBOARDING_ENABLED } from './onboardingConfig';

const ProtectedRoute = ({ children }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const emailParam = searchParams.get("email");

    window.addEventListener("storage", () => {
        if (localStorage.getItem('visiUserData') === null) {
            setWebsiteListData([]);
            navigate("/login");
        }
    });

    const isAdLookupMagicLink = location.pathname === "/ad-lookup" && Boolean(token);
    const isAdLookupEmail = location.pathname === "/ad-lookup" && Boolean(emailParam);
    const { isAuthenticated, setWebsiteListData, Permissions } = useAuth();

    if (!isAuthenticated && localStorage.getItem('visiUserData') === null) {
        if (isAdLookupMagicLink) {
            // allow magic link access without login
        } else if (isAdLookupEmail || location.pathname === "/open-test") {
            // redirect to login preserving the full URL (including email query, or a notification's test link)
            return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} />;
        } else {
            return <Navigate to="/login" />;
        }
    }
    const currentPath = window.location.pathname;

    const onboardingExempt = ["/onboarding", "/account_setup", "/logout"];
    const userData = visiUserData();
    if (
        ONBOARDING_ENABLED &&
        userData &&
        userData.onboarding_completed !== undefined &&
        Number(userData.onboarding_completed) === 0 &&
        !onboardingExempt.includes(currentPath) &&
        !isAdLookupRole() &&
        Number(userData.is_support) !== 1
    ) {
        return <Navigate to="/onboarding" />;
    }

    /*campaign_tab_access*/
    if (Permissions && Permissions.length > 0 && 
        ["/manage-campaigns", "/create-campaign", "/campaign-reports", "/campaign-report"].includes(currentPath)
    ) {
      if (!Permissions.includes("campaign_tab_access")) {
        return <NotFound />;
      }
    }

    /*heat_maps_access*/
    if (Permissions && Permissions.length > 0 && 
        ["/heat-maps", "/heatmap-view", "/create-heatmap"].includes(currentPath)
    ) {
      if (!Permissions.includes("heat_maps_access")) {
        return <NotFound />;
      }
    }

    /*scroll_maps_access*/
    if (Permissions && Permissions.length > 0 && 
        ["/scroll-maps", "/create-scrollmap", "/scrollmap-view"].includes(currentPath)
    ) {
      if (!Permissions.includes("scroll_maps_access")) {
        return <NotFound />;
      }
    }

    /*recordings_access*/
    if (Permissions && Permissions.length > 0 && 
        ["/recordings", "/recordings-list", "/recording-setting", "/recording-view"].includes(currentPath)
    ) {
      if (!Permissions.includes("recordings_access")) {
        return <NotFound />;
      }
    }

    const fullUrl = window.location.href;
    const invalidCharsRegex = /[#]/;
    if (invalidCharsRegex.test(fullUrl)) {
        return <NotFound />;
    }
    return children;
};

export default ProtectedRoute;